<template>
  <div v-loading="loading">
    <div v-if="data.IsComment" class="form">
      <el-input
        type="textarea"
        resize="none"
        :rows="8"
        maxlength="500"
        placeholder="购买课程后方可评论"
        v-model="Body"
      >
      </el-input>
      <div class="btns">
        <el-rate
          v-if="!data.MyEvaluateStarNum && data.IsEvaluate"
          allow-half
          v-model="StarNum"
          @change="submit(1)"
        ></el-rate>
        <el-rate
          v-if="data.MyEvaluateStarNum && data.IsEvaluate"
          allow-half
          disabled
          v-model="data.MyEvaluateStarNum"
        ></el-rate>
        <div v-if="!data.IsEvaluate"></div>
        <el-button
          type="primary"
          class="pad10 width100px"
          @click="submit(2)"
          style="background: #1d79ff"
          >评论</el-button
        >
      </div>
    </div>
    <div v-if="list && list.length > 0">
      <ul>
        <li v-for="(item, index) in list" :key="index" class="comment">
          <div class="comment-top">
            <div class="img"><img src="@/assets/img/home/54.png" alt="" /></div>
            <div class="name">{{ item.RealName || "匿名用户" }}</div>
            <div>{{ item.AddTimeTxt }}</div>
          </div>
          <div class="comment-bottom">
            {{ item.Body }}
          </div>
        </li>
      </ul>
      <el-pagination
        class="center mt30 mb70"
        @current-change="(page) => getList(page)"
        background
        :page-size="5"
        hide-on-single-page
        layout="prev, pager, next"
        :total="count"
      >
      </el-pagination>
    </div>
    <el-empty v-if="list.length == 0" description="暂无评论" :image="empty1" />
  </div>
</template>
<script>
import { Comment_GetList, Comment_Save, Evaluate_Save } from "@/api/common";
export default {
  name: "comment",
  data() {
    return {
      loading: false,
      PageIndex: 1,
      list: [],
      count: 0,
      Body: "",
      StarNum: null,
    };
  },
  props: {
    id: [String, Number],
    RelatedType: {
      type: [String, Number],
      default: 3, //1课程 2资料 3练习
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    id: {
      deep: true,
      handler(v) {
        this.getList(1);
      },
    },
  },
  components: {},
  created() {
    this.getList(1);
  },
  methods: {
    submit(type) {
      if (type == 1) {
        if (!this.data.MyEvaluateStarNum) {
          if (!this.StarNum) {
            this.$message.warning("请选择评分");
            return;
          }
          Evaluate_Save({
            StarNum: this.StarNum,
            RelatedID: this.id,
            RelatedType: this.RelatedType,
          }).then((res) => {
            if (res.code == 0) {
              this.$emit("update");
            } else {
              this.StarNum = 0;
            }
          });
        }
      } else {
        if (!this.Body) {
          this.$message.warning("请输入内容");
          return;
        }
        Comment_Save({
          Body: this.Body,
          RelatedID: this.id,
          RelatedType: this.RelatedType,
        }).then((res) => {
          if (res.code == 0) {
            this.$emit("update");
          }
        });
      }
    },
    getList(page) {
      this.loading = true;
      Comment_GetList({
        RelatedID: this.id,
        RelatedType: this.RelatedType,
        PageSize: 5,
        PageIndex: page,
      })
        .then((res) => {
          this.loading = false;
          this.list = res.data;
          this.count = res.count;
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  .btns {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
::v-deep .el-rate__icon {
  font-size: 24px;
}
.comment {
  width: 100%;
  border: none;
  border-bottom: 1px solid #e9ecf0;
  cursor: pointer;

  padding: 20px;
  color: #666666;
  .comment-top {
    display: flex;
    align-items: center;
    font-size: 20px;
    gap: 30px;
    .img {
      width: 36px;
      height: 36px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      font-size: 20px;
      color: #333333;
    }
  }
  .comment-bottom {
    word-break: break-all;
    padding-left: 66px;
    padding-top: 10px;
    font-size: 18px;
  }
}
</style>
